var portfolioTransactionAdd = {
	title: "Add transaction",
	subTitle: "Portfolio: {name}",
	buy: "Buy",
	sell: "Sell",
	currentNumberOfShares: "Current Quantity in Portfolio",
	buyDate: "Buy Date",
	sellDate: "Sell Date",
	quantity: "Quantity/Nominal",
	buyPrice: "Buy Price",
	exchangeRate: "Exchange Rate",
	exchangeRateFormat: "{from}/{to}",
	confirmBtn: "Ok",
	cancelBtn: "Cancel",
	buyValueInPortfolioCurrency: "Buy Value (portfolio currency)",
	buyValueInNotationCurrency: "Buy Value (notation currency)",
	sellValueInPortfolioCurrency: "Sell Value (portfolio currency)",
	sellValueInNotationCurrency: "Sell Value (notation currency)",
	sellPrice: "Sell Price",
	transactionType: "Transaction Type",
	validationErrors: {
		transactionType: {
			invalidInput: "Transaction type can be either buy or sell"
		},
		buyDate: {
			invalidInput: "Invalid date format. Valid format yyyy-MM-dd'T'HH:mm"
		},
		buyPrice: {
			invalidInput: "Invalid price"
		},
		exchangeRate: {
			invalidInput: "Invalid exchange rate"
		},
		quantity: {
			invalidInput: "Invalid quantity",
			limitExceeded: "Limit Exceeded"
		}
	}
};
var en = {
	portfolioTransactionAdd: portfolioTransactionAdd
};

export { en as default, portfolioTransactionAdd };
